export const backendBaseURL = process.env.VUE_APP_WEBSITE_BASE_URL;
export const adwordsAPIBaseURL = backendBaseURL + 'digital_marketing/';
export const apiAuthBaseURL = backendBaseURL + 'rest-auth/';
export const apiBaseURL = backendBaseURL + 'api/v1/';
export const callsAPIBaseURL = backendBaseURL + 'calls/';
export const condoAdministratorAPIBaseURL = backendBaseURL + 'condo_administrators/';
export const condominumAPIBaseURL = backendBaseURL + 'condos/';
export const contactNetworkAPIBaseURL = backendBaseURL + 'contacts/';
export const contractorsAPIBaseURL = backendBaseURL + 'contractors/';
export const coreAPIBaseURL = backendBaseURL + 'core/';
export const paymentApiBaseURL = backendBaseURL + 'payments/';
export const preorderApiBaseURL = backendBaseURL + 'preorders/';
export const quotationAPIBaseURL = backendBaseURL + 'quotations/';
export const surveyMonkeyAPIBaseURL = backendBaseURL + 'surveymonkey/';
export const magicLinkAPIBaseURL = backendBaseURL + 'magic-link-auth/';
export const suppliersAPIBaseURL = backendBaseURL + 'suppliers/';
export const baseURL = window.location.origin;
export const subscriptionHeaderApiBaseURL = backendBaseURL + 'api/v1/subscription_header_data/';
export const opportunitiesAPIBaseURL = backendBaseURL + 'opportunities/';
export const notificationsAPIBaseURL = backendBaseURL + 'notifications/';
export const transactionsAPIBaseURL = backendBaseURL + 'transactions/';
export const marketingAPIBaseURL = backendBaseURL + 'marketing/';
export const engelinkCreditAPIBaseURL = backendBaseURL + 'credits/';